import { mapGetters } from "vuex";

export default {
  name: "Header",

  computed: {
      ...mapGetters({ adminName: "adminName", adminId: "adminId" })
  },
};